import { renderIcon } from '../../SvgIcon.esm.js';

/******************************************************
 * This file was created by scripts/generate.js as part
 * of the build process. Do not edit this file directly.
 ******************************************************/
var iconType = {
  viewBox: "0 0 24 24",
  paths: [{
    d: "M12 2C6.4286 2 2 6.4286 2 12s4.4286 10 10 10 10-4.4286 10-10S17.5714 2 12 2zm.6602 7.5995c-.6296 0-1.1171.2365-1.4625.7096-.3454.4732-.5181 1.1325-.5181 1.978 0 1.7593.6602 2.639 1.9806 2.639.554 0 1.225-.1385 2.013-.4156v1.4032c-.6476.2698-1.3708.4048-2.1695.4048-1.1477 0-2.0256-.3481-2.6336-1.0443-.608-.6962-.912-1.6955-.912-2.998 0-.8203.1492-1.539.4478-2.156.2987-.617.7277-1.0901 1.2872-1.4193.5594-.3292 1.2152-.4938 1.9671-.4938.7664 0 1.5363.1853 2.3098.5559l-.5396 1.36a8.9333 8.9333 0 00-.8905-.367c-.2986-.1044-.5919-.1565-.8797-.1565z",
    fillRule: "evenodd"
  }],
  circles: []
};
var CreditNoCreditIcon = function CreditNoCreditIcon(props) {
  return renderIcon(props, iconType);
};
export { CreditNoCreditIcon };